import React, { useEffect, useRef, useState } from "react";
import { PrinterFill } from "react-bootstrap-icons";
import ReactToPrint from "react-to-print";
import PdfTemplate from "../undercompo/Template";
import InsAdd from "../undercompo/insAdd";
import config from "./config";
import PrintHeader from "../undercompo/printHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "./printheader.css";

export default function Inscriptions() {
  const [insData, setInsData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [record, setRecord] = useState([]);
  const [classe, setClData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [niveauData, setNiveauData] = useState([]);
  const [ecData, setEcData] = useState({});
  const [enable, setEnable] = useState(true);
  const [lab, setLab] = useState("Liste des élèves inscrits");
  const [currentMode, setCurrentMode] = useState("inscrits");
  const [selectedClass, setSelectedClass] = useState("");
  const componentPdf = useRef();
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const defaultLabel = currentMode === "inscrits" ? "Liste des élèves inscrits" : "Liste des élèves non-inscrits";
    setLab(selectedClass ? `${defaultLabel} - ${selectedClass}` : defaultLabel);
  }, [selectedClass, currentMode]);

  const fetchData = async () => {
    try {
      const [insRes, studentRes, classeRes, niveauRes, schoolRes] = await Promise.all([
        fetch(`${config.apiBaseUrl}/ins.php`).then(res => res.json()),
        fetch(`${config.apiBaseUrl}/l.php`).then(res => res.json()),
        fetch(`${config.apiBaseUrl}/classe.php`).then(res => res.json()),
        fetch(`${config.apiBaseUrl}/niveau.php`).then(res => res.json()),
        fetch(`${config.apiBaseUrl}/schoolUp.php/1`).then(res => res.json()) // Fetching school data
      ]);

      setInsData(insRes?.sort((a, b) => a.nom.localeCompare(b.nom)) || []);
      setStudentData(studentRes?.sort((a, b) => a.nom.localeCompare(b.nom)) || []);
      setClData(classeRes);
      setNiveauData(niveauRes);
      setEcData(schoolRes || {}); // Ensure ecData is set properly
      setRecord(insRes ?? []);
    } catch (error) {
      console.error("Erreur lors du chargement des données :", error);
    }
  };

  const handleNiveau = (e) => {
    const niveauId = e.target.value;
    setClassData(niveauId ? classe.filter(s => s.niveau === niveauId) : []);
    setEnable(!niveauId);
  };

  const handleTri = (e) => {
    const selectedClass = e.target.value;
    setSelectedClass(selectedClass);
    setRecord((currentMode === "inscrits" ? insData : studentData).filter(({ classe }) => classe === selectedClass));
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setRecord((currentMode === "inscrits" ? insData : studentData).filter(({ nom }) => nom.toLowerCase().includes(searchTerm)));
  };

  const handleInscrits = () => {
    setRecord(insData);
    setCurrentMode("inscrits");
  };

  const handleNonInscrits = async () => {
    try {
      const res = await fetch(`${config.apiBaseUrl}/ins.php`).then(req => req.json());
      const nonInscrits = studentData.filter(stu => !res.some(ins => stu.matricule === ins.matricule));
      setRecord(nonInscrits);
      setCurrentMode("non-inscrits");
    } catch (error) {
      console.error("Erreur lors de la récupération des non-inscrits :", error);
    }
  };

  return (
    <main className="main-container">
      <h3>Bienvenue sur la gestion des inscriptions</h3>
      <div className="container">
        <div className="row mb-3">
          <div className="form-group col-md-4">
            <label className="mb-2">Niveau</label>
            <select name="niveau" className="form-control" onChange={handleNiveau}>
              <option value="">Sélectionnez le Niveau</option>
              {niveauData.map(({ id, libellee_niveau }) => (
                <option key={id} value={id}>{libellee_niveau}</option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-4">
            <label className="mb-2">Classe</label>
            <select name="classe" disabled={enable} onChange={handleTri} className="form-control">
              <option value="">Sélectionnez la classe</option>
              {classData.map(({ libellé_classe }, index) => (
                <option key={index}>{libellé_classe}</option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-4">
            <label className="mb-2">Rechercher</label>
            <input type="search" placeholder="Tapez le nom" onChange={handleSearch} className="form-control" />
          </div>
        </div>

        <div className="row">
          <div className="btn-group col-md-4">
            <button className="btn btn-outline-primary" onClick={handleInscrits}>Inscrits</button>
            <button className="btn btn-outline-primary" onClick={handleNonInscrits}>Non inscrits</button>
          </div>
          <div className="col-md-4">
            <ReactToPrint 
              trigger={() => <button className="btn btn-success" onClick={() => setIsPrinting(true)}><PrinterFill /> Imprimer</button>} 
              content={() => componentPdf.current} 
              onBeforePrint={() => setIsPrinting(true)}
              onAfterPrint={() => setIsPrinting(false)}
            />
          </div>
        </div>
      </div>

      <h3><strong>{lab}</strong></h3>
      <div ref={componentPdf} className="print-section">
        <div className="print-only">
          <PrintHeader ecData={ecData} lab={lab} selectedClass={selectedClass} />
        </div>
        
        <table className="table table-striped table-bordered w-auto">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Matricule</th>
              <th>Nom</th>
              <th>Classe</th>
              <th>Versé</th>
              <th>Reste</th>
              <th className="action-column">Action</th>
            </tr>
          </thead>
          <tbody>
            {record.length === 0 ? (
              <tr><td colSpan="7">Aucune donnée disponible</td></tr>
            ) : (
              record.map(({ id, matricule, nom, classe, montant, reste }, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{matricule}</td>
                  <td>{nom}</td>
                  <td>{classe}</td>
                  <td>{montant ? `${montant} FCFA` : "-"}</td>
                  <td>{reste ? `${reste} FCFA` : "-"}</td>
                  <td className="action-column">
                    {currentMode === "inscrits" ? <PdfTemplate data={{ id, matricule, nom, classe, montant, reste }} /> : <InsAdd data={{ matricule, nom, classe }} />}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}
